/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoicingModeResource = {
    Direct: 'DIRECT',
    Intermediation: 'INTERMEDIATION'
} as const;
export type InvoicingModeResource = typeof InvoicingModeResource[keyof typeof InvoicingModeResource];


export function instanceOfInvoicingModeResource(value: any): boolean {
    for (const key in InvoicingModeResource) {
        if (Object.prototype.hasOwnProperty.call(InvoicingModeResource, key)) {
            // @ts-ignore
            if (InvoicingModeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvoicingModeResourceFromJSON(json: any): InvoicingModeResource {
    return InvoicingModeResourceFromJSONTyped(json, false);
}

export function InvoicingModeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicingModeResource {
    return json as InvoicingModeResource;
}

export function InvoicingModeResourceToJSON(value?: InvoicingModeResource | null): any {
    return value as any;
}

